import BaseModel from '@/orm/models/BaseModel';

export default class Integration extends BaseModel {
  static entity = 'integrations'

  static fields() {
    return {
      name: this.string(null).nullable(),
      link: this.string(null).nullable(),
      id: this.attr(null),
      code: this.string(null),
      connected: this.attr(null),
      logoUrl: this.attr(null),
      integrationEmail: this.attr(null),
    };
  }

  static apiConfig = {
    actions: {
      fetchAll() {
        return this.get('integrations', {
          dataTransformer: (r) => {
            return r.data.data.map((i) => i);
          },
        });
      },
      getLink(code) {
        return this.get(`integrations/link?code=${code}`, { save: false });
      },
      disable(companyId, integrationId) {
        return this.delete(`companies/${companyId}/integrations/${integrationId}`);
      },
      getRegistrationData() {
        return this.get('integrations/registration-data', { save: false });
      },
      registerCompany(payload) {
        return this.post('companies/integrations/register', payload, { save: false });
      },
    },
  }
}
